import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _get from 'lodash/get';
import PillComp from 'components/Pill/Pill';
import Tooltip from 'components/Tooltip/Tooltip';
import { SCHEDULE_FORM } from 'constants/ScheduleModal';
import classes from './ScheduleSearchBar.module.scss';

const messages = defineMessages({
  search: { id: 'components.schedule.search', defaultMessage: 'Choose or search' },
  selfResult: { id: 'search.schedule.self', defaultMessage: 'Call me directly' }
});

export class ScheduleSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderText: props.intl.formatMessage(messages.search),
      autoFocus: false
    };
    this.clearSelectedSchedule = this.props.clearSelectedSchedule.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.props.handleSetIsFocused(nextProps.isFocused);
    this.setState({
      autoFocus: true
    });
  }

  focusHandler = () => {
    this.props.handleSetIsFocused(true);
  };

  scheduleInput = props => {
    const pillLabel = this.renderPill();
    const hasLongLabel = _get(pillLabel, 'length') > 32;
    return ((props.contact && props.contact.name) ? (
      <div className={classes.selectedSchedule}>
        <PillComp
          disabled={false}
          id={props.contact.id}
          onRemove={this.clearSelectedSchedule}
          value={props.contact}
        >
          {hasLongLabel && <Tooltip label={pillLabel} className={classes.wrapTooltip} />}
          <span className={classes.pillLabel}>{pillLabel}</span>
        </PillComp>
      </div>
    ) : (
      <input
        type="text"
        {...props.input}
        placeholder={this.state.placeholderText}
        onFocus={this.focusHandler}
        className={classes.scheduleInput}
        autoFocus={this.state.autoFocus}
        data-testid="scheduleSearch"
        maxLength={200}
      />
    ));
  };

  searchBar = () => <div>
    <Field
      name={SCHEDULE_FORM}
      component={this.scheduleInput}
      type="text"
      contact={this.props.contact}
    />
  </div>;

  renderPill = () => {
    if (_get(this.props.contact, 'id') === _get(this.props.currentUser, 'id')) {
      return this.props.intl.formatMessage(messages.selfResult);
    }

    return this.props.contact.name;
  };

  render() {
    return (
      this.searchBar()
    );
  }
}

ScheduleSearchForm.propTypes = {
  intl: PT.object,
  contact: PT.object,
  currentUser: PT.object,
  clearSelectedSchedule: PT.func,
  handleSetIsFocused: PT.func,
  isFocused: PT.bool,
};

export default reduxForm({
  form: SCHEDULE_FORM,
  getFormState: state => state.app.form
})(injectIntl(ScheduleSearchForm));
